// react
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// css
import './styles.scss'

// component
import { Value } from '@st-operations/uikit/src/v2/index.js'

// lib
import classnames from 'classnames'
import isEqual from 'react-fast-compare'

class ItemInfoCell extends Component {
  shouldComponentUpdate(next_props, next_state) {
    let is_props_equal = isEqual(this.props, next_props)
    let is_state_equal = isEqual(this.state, next_state)
    return !is_props_equal || !is_state_equal
  }

  getListValues = (item, field) => {
    if (Array.isArray(item[field[0]])) {
      return item[field[0]].map((elem) => elem[field[1]]).join(', ')
    }
  }

  componentDidMount = () => {
    let { onLoad, item } = this.props
    if (onLoad) {
      onLoad(item)
    }
  }

  componentDidUpdate = () => {
    let { onUpdate, item } = this.props
    if (onUpdate) {
      onUpdate(item)
    }
  }

  onClick = (e) => {
    let { onClick } = this.props
    if (onClick && typeof onClick === 'function') {
      onClick(e, this.props.name, this.props.value)
    }
  }

  renderStringField = (field) => {
    return (
      <div className="st-item-info-cell__field" key={field}>
        <span className="st-item-info-cell__field--label">
          {typeof field === 'string' ? `${field}:` : ''}
        </span>
        <span className="st-item-info-cell__field--value">
          <Value value={this.props.item[field]} />
        </span>
      </div>
    )
  }

  renderArrayFirstElement = (field) => {
    return (
      <div className="st-item-info-cell__field" key={field}>
        <span className="st-item-info-cell__field--label">
          {typeof field[0] === 'string' ? `${field[0]}:` : ''}
        </span>
        <span className="st-item-info-cell__field--value">
          <Value value={this.getListValues(this.props.item, field)} />
        </span>
      </div>
    )
  }

  renderFullList = (field) => {
    const list = this.props.item[field.root]
    if (list.length > 0) {
      return (
        <div className="st-item-info-cell__field" key={field.root}>
          <span className="st-item-info-cell__field--label">
            {typeof field === 'string' ? `${field}:` : ''}
          </span>
          {list.map((item) => (
            <div key={item[field.props[0]]}>
              <span className="st-item-info-cell__field--value">{`${item[field.props[0]]}: ${
                item[field.props[1]]
              }`}</span>
            </div>
          ))}
        </div>
      )
    }
    return ''
  }

  renderLink(node) {
    const { href, link } = this.props
    return (
      <Choose>
        <When condition={link}>
          <Link key={link} to={link}>
            {node}
          </Link>
        </When>
        <When condition={href}>
          <a href={href} key={href} target="_blank" rel="noopener noreferrer">
            {node}
          </a>
        </When>
        <Otherwise>
          <span key={node.toString()} onClick={this.onClick}>
            {node}
          </span>
        </Otherwise>
      </Choose>
    )
  }

  render() {
    let { fields, item, nameSingleLine, className, prefixClassName, suffixClassName } = this.props
    // cleanup and format name
    let name = item.name && item.name.replace(/^\*/, '')
    let name_parts = name && name.split(/\||\s-\s|\s--->\s|\s>\s/)
    let name_last_part = name_parts && name_parts[name_parts.length - 1]
    let name_prefix = name_parts && name_parts.slice(0, -1).join(' > ')

    return (
      <div className={classnames('st-item-info-cell', className)}>
        {name_prefix && (
          <p
            className={classnames('st-item-info-cell__name-prefix', prefixClassName)}
            title={name_prefix ? `${name_prefix} > ${name_last_part}` : name_last_part}
            onClick={this.onClick}
          >
            {name_prefix}
          </p>
        )}
        {name_last_part &&
          this.renderLink(
            <p
              className={classnames('st-item-info-cell__name-sufix', suffixClassName)}
              title={name_prefix ? `${name_prefix} > ${name_last_part}` : name_last_part}
            >
              {name_prefix && !nameSingleLine ? `${name_last_part}` : name_last_part}
            </p>
          )}
        {this.props.actions?.(item)}
        {fields &&
          fields.length > 0 &&
          fields.map((field) => {
            switch (true) {
              case typeof field === 'string':
                return this.renderStringField(field)
              case Array.isArray(field):
                return this.renderArrayFirstElement(field)
              case typeof field === 'object':
                return this.renderFullList(field)
              default:
                return ''
            }
          })}
      </div>
    )
  }
}

// export
export default ItemInfoCell
